import React, { lazy } from 'react';
import { useLoginPageViewed } from './hooks/useLoginPageViewed';
import { LoginTooManyAttemptsRecaptchaContextProvider } from './contexts/LoginTooManyAttemptsRecaptchaContext';
import { LoginRecoveryOptionsContextProvider } from './contexts/LoginRecoveryOptionsContext';
import { LoginGoogleOneTapRenderBoundary } from './components/LoginGoogleOneTap';
import { MarketingConsentContextProvider } from './contexts/LoginMarketingConsentContext';
import { useShouldOrchestrate } from '../orchestrator';

import OrchestratedLoginPage from './OrchestratedPage';

const BasePage = lazy(() => import('./BasePage'));

const LoginPage = () => {
  useLoginPageViewed();
  const shouldOrchestrate = useShouldOrchestrate();

  return (
    <LoginTooManyAttemptsRecaptchaContextProvider>
      <LoginRecoveryOptionsContextProvider>
        <LoginGoogleOneTapRenderBoundary>
          <MarketingConsentContextProvider>
            {shouldOrchestrate ? <OrchestratedLoginPage /> : <BasePage />}
          </MarketingConsentContextProvider>
        </LoginGoogleOneTapRenderBoundary>
      </LoginRecoveryOptionsContextProvider>
    </LoginTooManyAttemptsRecaptchaContextProvider>
  );
};

export default LoginPage;
